import * as React from 'react';
import AgentLogsSMSPanel from '../Panels/AgentLogsSMSPanel';
import AgentLogsCallsPanel from '../Panels/AgentLogsCallsPanel';
import AgentLogsWebhookPanel from '../Panels/AgentLogsWebhookPanel';
import { UserEmailActivity } from '../Components/EmailActivity/UserEmailActivity';

enum SECTION_TAB {
  CALL_LOGS = 'call-logs',
  SMS_LOGS = 'sms-logs',
  EMAIL_LOGS = 'email-logs',
  WEBHOOK_CHECK = 'webhooks',
}

type SectionTab = {
  id: SECTION_TAB;
  label: string;
  successClass: string;
  icon: string;
};

export interface AgentLogsPageProps {}

export default function AgentLogsPage(props: AgentLogsPageProps): React.JSX.Element {
  const [currentTab, setCurrentTab] = React.useState<SECTION_TAB>(SECTION_TAB.CALL_LOGS);

  const sections: SectionTab[] = [
    {
      id: SECTION_TAB.CALL_LOGS,
      label: 'Call Logs',
      successClass: 'btn-primary',
      icon: 'fa-phone',
    },
    {
      id: SECTION_TAB.EMAIL_LOGS,
      label: 'Email Logs',
      successClass: 'btn-primary',
      icon: 'fa-at',
    },
    {
      id: SECTION_TAB.WEBHOOK_CHECK,
      label: 'Data Status',
      successClass: 'btn-primary',
      icon: 'fa-network-wired',
    },
  ];

  return (
    <>
      <div className="row mb-3">
        <div className="col-12 mb-2">
          {sections.map((tab) => {
            const buttonClassList = ['btn', 'btn-sm', 'mr-2'];

            if (currentTab === tab.id) {
              buttonClassList.push(tab.successClass);
            } else {
              buttonClassList.push('border-secondary');
            }

            const iconClassList = ['far', tab.icon];

            return (
              <span
                onClick={(e) => {
                  setCurrentTab(tab.id);
                }}
                key={tab.id}
                className={buttonClassList.join(' ')}
              >
                <i className={iconClassList.join(' ')}></i> {tab.label}
              </span>
            );
          })}
        </div>
        <div className="col-12 mb-2">
          {currentTab === SECTION_TAB.CALL_LOGS && <AgentLogsCallsPanel />}
          {currentTab === SECTION_TAB.SMS_LOGS && <AgentLogsSMSPanel />}
          {currentTab === SECTION_TAB.WEBHOOK_CHECK && <AgentLogsWebhookPanel />}
          {currentTab === SECTION_TAB.EMAIL_LOGS && <UserEmailActivity />}
        </div>
      </div>
    </>
  );
}
